import Link from 'next/link';
import { useRouter } from 'next/router';

import { Colors } from '../components/general';
import Navbar from '../components/navbar';
import Page, { Content } from '../components/page';

const About: React.FC = () => {
  const router = useRouter();

  return (
    <Page className="bg-gray-100">
      <Navbar showDismiss onAction={() => router.push('/feed')} />

      <Content>
        <div className="mx-4 mt-8 mb-8 flex flex-col">
          <p className={`font-semibold text-3xl text-${Colors.black}`}>About</p>
          <p className={`mt-8 text-${Colors.black}`}>
            Postdates is a <span className="italic">fully operational</span> parody of a company that goes by a very
            similar name. It&apos;s what happens when{' '}
            <a
              href="https://twitter.com/atlasacopian"
              target="_blank"
              rel="noreferrer"
              className="text-pink-400 font-medium"
            >
              Atlas Acopian
            </a>{' '}
            and{' '}
            <a
              href="https://twitter.com/suzyshinn"
              target="_blank"
              rel="noreferrer"
              className="text-pink-400 font-medium"
            >
              Suzy Shinn
            </a>{' '}
            take another idea too far. Alongside product developer{' '}
            <a href="https://twitter.com/bhwags" target="_blank" rel="noreferrer" className="text-pink-400 font-medium">
              Brian Wagner
            </a>
            , the trio took to build a functioning pop-up business designed to bring humor to an otherwise shitty
            situation.
          </p>
          <p className={`mt-4 text-${Colors.black}`}>
            Postdates works just like your favorite delivery app, but in break-up form 😉{' '}
          </p>
          <p className={`mt-4 text-${Colors.black}`}>
            Yes, it actually works. We designed Postdates to get your stuff back from (or send stuff back to) your
            ex...or just someone who you&apos;re no longer in direct contact with. Remember that hoodie you let them
            borrow? Now, you can get it back. Divorced? Ghosted? Friendzoned? We&apos;ve got you. For a limited time
            only.
          </p>

          <p className={`mt-4 text-${Colors.black}`}>
            Still have questions? Visit our{' '}
            <Link href="/faq">
              <span className="text-pink-400 font-medium cursor-pointer">FAQ Page</span>
            </Link>
            .
          </p>

          <p className={`mt-8 italic text-${Colors.black}`}>
            A very special thank you to <span className="font-bold">our delivery partners</span> —{' '}
            <a href="https://airpals.net" target="_blank" rel="noreferrer" className="text-pink-400">
              Airpals
            </a>{' '}
            (New York) and{' '}
            <a href="https://www.gourmetrunnerla.com" target="_blank" rel="noreferrer" className="text-pink-400">
              Gourmet Runner
            </a>{' '}
            (Los Angeles).
          </p>

          <p className={`mt-1 italic text-${Colors.black}`}>
            To{' '}
            <a href="https://baileyjames.co" target="_blank" rel="noreferrer" className="text-pink-400">
              Bailey James
            </a>{' '}
            for our logo and branding{' '}
            <a href="https://displaay.net" target="_blank" rel="noreferrer" className="text-pink-400">
              Displaay
            </a>{' '}
            for our{' '}
            <a href="https://displaay.net/typeface/matter" target="_blank" rel="noreferrer" className="text-pink-400">
              Matter
            </a>{' '}
            font,{' '}
            <a href="https://www.instagram.com/sliizzz" target="_blank" rel="noreferrer" className="text-pink-400">
              Carlos Estrada
            </a>
            , Patrick Toner, and Joel Williams for our 3D animations, and to{' '}
            <a href="https://www.instagram.com/goos1e" target="_blank" rel="noreferrer" className="text-pink-400">
              goos1e
            </a>{' '}
            for our merch designs.
          </p>

          <p className={`mt-1 italic text-${Colors.black}`}>
            To Max Hellerstein and Rayne Palombit for absolutely everything big and small. This wouldn&apos;t have
            happened without you. To Dan Brier, Jeremiah Warren, Collin Fioriglio, Atiya Walcott, Tyler Lydell, Rachel
            White, Kristina Zimmerman, Roberto Ortiz for helping bring our brand video to life. And to our friends Cody
            Guilfoyle, MaiLinh Nguyen, Kurt Stadelman, Alex Lewis, Jeni&apos;s Ice Cream, Thi Q. Lam, Sara Jensen,
            Suraya Shivji, Narek Khachatryan, Helena Price Hambrecht, Shaina Denny, Kashi Somers, Cole Hersch, Jon Paul
            Douglass, Alex Brown, Phil Woods, Cara Salimando, Sean Robinson, Joel Williams, Nikki Winn, Emma Gilberg,
            Reta Gasser, Anabel Pasarow, Julie Logan, Jack Gorlin, Colton Williams, Olivia Glick, Cecilia
            Cereijido-Bloche, Devin Lewtan and all of our parents — none of this would have been possible without you.
          </p>
        </div>
      </Content>
    </Page>
  );
};

export default About;
